export const StatusIndicator = ({ className = "" }) => (
    <div
        data-testid="status-indicator"
        className={`inline-flex items-center gap-2.5 rounded-full border border-[#D4AF37]/25 bg-black/50 px-4 py-2 backdrop-blur-xl ${className}`}
    >
        <span className="pulse-dot h-2 w-2 rounded-full bg-[#D4AF37]" />
        <span className="text-xs font-medium tracking-[0.22em] uppercase text-[#F3E5AB]">
            Online 24/7 — Siap Melayani
        </span>
    </div>
);
